import type { ApiIdResult } from "@/types/task-actions";

/** Normalizes GET/POST responses that return Swagger `ApiIdResult`. */
export function parseApiIdResult(data: unknown): ApiIdResult {
  if (data == null || typeof data !== "object") {
    return { success: false, reason: "Invalid response from server.", id: 0 };
  }
  const o = data as Record<string, unknown>;
  const successRaw = o.success ?? o.Success;
  const reasonRaw = o.reason ?? o.Reason ?? null;
  const idRaw = o.id ?? o.ID ?? 0;
  const lockedRaw = o.locked ?? o.Locked;
  const errorRaw = o.error ?? o.Error ?? null;
  return {
    success: successRaw === true,
    reason: reasonRaw != null && String(reasonRaw).trim() !== "" ? String(reasonRaw) : null,
    id: typeof idRaw === "number" ? idRaw : Number(idRaw) || 0,
    locked: lockedRaw === true ? true : undefined,
    error: errorRaw != null && String(errorRaw).trim() !== "" ? String(errorRaw) : null,
  };
}
